export default [
  {
    path: '/mng/account/corpUdf',
    name: 'corpUdf',
    component: () => import('@/pages/mng/system_manager/customField/App.vue'),
    meta: {
      title: '自定义字段',
    },
  },
  {
    path: '/mng/account/integration/settings',
    name: 'settings',
    component: () => import('@/pages/mng/system_manager/interfaceConfig/App.vue'),
    meta: {
      title: '接口配置',
    },
  },
];
